import _styled, { css as _css } from "styled-components";
import React from "react";
import { useNavLayout } from "~/features/app/app-header-v2/context";
const backdropStyles = /*#__PURE__*/_css(["transition:all 0.4s cubic-bezier(0.125,0.425,0.27,1);", " ", " left:0;right:0;z-index:99;"], {
  "position": "absolute",
  "willChange": "transform"
}, {
  "pointerEvents": "none"
});
export function NavDropdownBackdrop() {
  const {
    activeDropdown,
    dropdownHeight,
    isAnnouncementBarVisible,
    isPageHighlighted
  } = useNavLayout();
  const [backdropHeight, setBackdropHeight] = React.useState(0);
  const backdropRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (activeDropdown && backdropRef.current) {
      const announcementBarHeight = isAnnouncementBarVisible ? parseInt(getComputedStyle(document.documentElement).getPropertyValue("--announcement-bar-height")) || 0 : 0;
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 0;
      const maxAllowedHeight = window.innerHeight - announcementBarHeight - headerHeight - 60;
      setBackdropHeight(Math.min(dropdownHeight, maxAllowedHeight));
    } else {
      setBackdropHeight(0);
    }
  }, [activeDropdown, dropdownHeight, isAnnouncementBarVisible]);
  return <_StyledDiv ref={backdropRef} style={{
    top: "var(--header-height)",
    height: `${backdropHeight}px`,
    opacity: activeDropdown ? 1 : 0
  }} aria-hidden="true" $_css2={[backdropStyles, isPageHighlighted ? {
    "backgroundColor": "var(--white-static)"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))"
  }]} />;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "nav-dropdown-backdrop___StyledDiv",
  componentId: "sc-awi4d-0"
})(["", ""], p => p.$_css2);